<template>
  <div class="container-fluid">
    <div class="row marketing">
      <div class="col-3">
        <!-- form -->
        <h4 class="form-head">Generate EWaybills</h4>

        <form @submit.prevent="generateEWB">
          <div class="form-group">
            <label for="exampleInputEmail0">Generate For</label>
            <select class="form-control"
                    v-model="selectedCred"
                    @change="selectCred"
                    id="exampleInputEmail0">
              <option v-for="c of creds" :key="c.id" :value="c.id">{{c.state}} - {{c.gstNumber}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="genType">Type</label>
            <select class="form-control" id="genType" v-model="genType">
              <option value="IMPORT">IMPORT</option>
              <option value="SALES">SALES</option>
              <option value="RETURN">RETURN</option>
            </select>
          </div>

          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="transporterId">Transporter ID</label>
            <input type="text" class="form-control" id="transporterId" v-model="transporterId">
          </div>
          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="pinCode">PinCode Of Import</label>
            <input type="text" class="form-control" id="pinCode" v-model="pinCode">
          </div>
          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="stateCode">State Of Import (KA/MH/TN)</label>
            <input type="text" class="form-control" id="stateCode" v-model="stateCode">
          </div>

          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="consigneePIN">PinCode Of Destination Place</label>
            <input type="text" class="form-control" id="consigneePIN" v-model="consigneePIN">
          </div>

          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="vehicleNo">Vehicle No</label>
            <input type="text" class="form-control" id="vehicleNo" v-model="vehicleNo">
          </div>

          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="docketNo">Docket No</label>
            <input type="text" class="form-control" id="docketNo" v-model="docketNo">
          </div>

          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="fromAddress">From Address</label>
            <input type="text" class="form-control" id="fromAddress" v-model="fromAddress">
          </div>

          <div class="form-group" v-if="genType === 'IMPORT'">
            <label for="toAddress">To Address</label>
            <input type="text" class="form-control" id="toAddress" v-model="toAddress">
          </div>
          <div class="form-group" style="display: none">
            <label for="jobServer">Job Server</label>
            <input type="text" class="form-control" id="jobServer" v-model="jobServer">
          </div>
          <div class="form-group">
            <label for="exampleInputPassword2">Select CSV File</label>
            <input type="file" class="form-control" id="exampleInputPassword2" @change="processFile($event)">
          </div>

          <button type="submit" class="btn btn-primary">Generate</button>
        </form>
      </div>
      <div class="col-9" v-if="jobs.length > 0">
        <!-- history -->
        <h4 class="form-head">Jobs</h4>
        <table class="table table-bordered table-sm">
          <thead class="thead-default">
          <tr>
            <th>Request ID</th>
            <th>Status</th>
            <th>Generated By</th>
            <th>Request Count</th>
            <th>Success Count</th>
            <th>Failure Count</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="j of jobs" :key="j.requestId">
            <td>{{j.requestId}}</td>
            <td>{{j.status}}</td>
            <td>{{j.credentials.gstNumber}}</td>
            <td>{{j.totalCount}}</td>
            <td>{{j.successCount}}</td>
            <td>{{j.failureCount}}</td>
            <td>
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-success"
                        @click.prevent="selectJob(j)">Select
                </button>
                <button type="button" class="btn btn-danger"
                        @click.prevent="removeJob(j)">Clear
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <!-- current Job -->
        <h4 v-if="selectedJob" class="form-head">Forms for {{selectedJob.requestId}}</h4>

        <table class="table" v-if="selectedJob">
          <thead class="thead-default">
          <tr>
            <th>Consignor</th>
            <th>Consignee</th>
            <th>Transporter</th>
            <th>Invoice</th>
            <th>EWaybill</th>
            <th>
              <form :action="printAllNewUrl(selectedJob)" target="_blank" method="post">
                <input type="hidden" name="ewb" v-for="(ex, idx) of validEwbs(selectedJob)" :key="idx"
                       :value="ex.ewaybill"/>
                <input type="hidden" name="inv" v-for="(ex, idx) of validEwbs(selectedJob)" :key="idx"
                       :value="ex.invoice.invoiceNo"/>
                <button
                  type="submit"
                  class="btn btn-info btn-xs"
                  v-if="selectedJob.status === 'COMPLETED'">
                  Print
                </button>
              </form>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="f of selectedJob.ewaybills" :key="f.formId">
            <td>
              {{f.consignor.name}} <br/>
              {{f.consignor.pinCode}} <br/>
              {{f.consignor.gstNumber}}
            </td>
            <td>
              {{f.consignee.name}} <br/>
              {{f.consignee.pinCode}} <br/>
              {{f.consignee.gstNumber}}
            </td>
            <td>
              ID: {{f.transporter.id}} <br/>
              DOC: {{f.transporter.docNo}} <br/>
              MODE: {{f.transporter.transportMode}} <br/>
              VEH: {{f.transporter.vehicleNo}} <br/>
            </td>
            <td>
              {{f.invoice.docType}} # {{f.invoice.invoiceNo}} <br/>
              Dt {{fmt(f.invoice.invoiceDt)}} <br/>
              Rs {{f.invoice.invoiceVal}} <br/>

              <ol style="font-size:xx-small;padding-left: 5px">
                <li v-for="li of f.lineItems" :key="li.itemId">
                  {{li.hsnCode}} -
                  <span v-if="li.cgstRate > 0">S/CGST @ {{li.cgstRate}}%</span>
                  <span v-if="li.igstRate > 0">IGST @ {{li.igstRate}}%</span>
                  <span v-if="li.igstRate === 0 && li.cgstRate === 0">0%</span> -
                  {{li.qty}} NOS
                </li>
              </ol>
            </td>
            <td>
              {{f.ewaybill}} <br/>
              <span v-if="f.errorMsg" style="color:red">{{f.errorMsg}}</span>
            </td>
            <td>
              <a v-if="f.ewaybill"
                 :href="printUrl(f)"
                 target="_blank">Print</a>
              <div v-if="f.generating && selectedJob.status !== 'COMPLETED'">
                <svg
                  class="lds-spinner" width="96px" height="96px" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"
                  style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
                  <g transform="rotate(0 50 50)">
                    <rect x="48" y="37" rx="4.8" ry="3.7" width="4" height="6" fill="#0055a5">
                      <animate attributeName="opacity" values="1;0" times="0;1" dur="1s"
                               begin="-0.8333333333333334s" repeatCount="indefinite"></animate>
                    </rect>
                  </g>
                  <g transform="rotate(60 50 50)">
                    <rect x="48" y="37" rx="4.8" ry="3.7" width="4" height="6" fill="#0055a5">
                      <animate attributeName="opacity" values="1;0" times="0;1" dur="1s"
                               begin="-0.6666666666666666s" repeatCount="indefinite"></animate>
                    </rect>
                  </g>
                  <g transform="rotate(120 50 50)">
                    <rect x="48" y="37" rx="4.8" ry="3.7" width="4" height="6" fill="#0055a5">
                      <animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.5s"
                               repeatCount="indefinite"></animate>
                    </rect>
                  </g>
                  <g transform="rotate(180 50 50)">
                    <rect x="48" y="37" rx="4.8" ry="3.7" width="4" height="6" fill="#0055a5">
                      <animate attributeName="opacity" values="1;0" times="0;1" dur="1s"
                               begin="-0.3333333333333333s" repeatCount="indefinite"></animate>
                    </rect>
                  </g>
                  <g transform="rotate(240 50 50)">
                    <rect x="48" y="37" rx="4.8" ry="3.7" width="4" height="6" fill="#0055a5">
                      <animate attributeName="opacity" values="1;0" times="0;1" dur="1s"
                               begin="-0.16666666666666666s" repeatCount="indefinite"></animate>
                    </rect>
                  </g>
                  <g transform="rotate(300 50 50)">
                    <rect x="48" y="37" rx="4.8" ry="3.7" width="4" height="6" fill="#0055a5">
                      <animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="0s"
                               repeatCount="indefinite"></animate>
                    </rect>
                  </g>
                </svg>
              </div>
            </td>
          </tr>
          </tbody>
        </table>


      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Papa from 'papaparse'
import _ from 'lodash'
import moment from 'moment'
import Loading from '@/components/shared/Loading'

let credUrl = `/app/cred`

let parseDate = (str) => {
  let formats = ['DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY',
    'DD.MM.YY', 'DD-MMM-YY', 'DD/MM/YY', 'YYYY-MM-DD', 'YYYY/MM/DD']
  let firstValid = _.head(formats.map(fmt => moment(str.toUpperCase(), fmt, true))
    .filter(m => m.isValid()))
  console.log(str, ' Valid Date Found?', firstValid)
  if (!firstValid) return ""
  return firstValid.format("YYYY-MM-DD")
}
let uuid = () => {
  return Math.random().toString(36).substring(2, 15)
}

let parseTransportMode = (mode) => {
  let modes = ['AIR', 'ROAD', 'SHIP', 'RAIL']
  if (modes.indexOf(mode) > -1) {
    return mode
  }
  if (mode === 'SURFACE') return 'ROAD'

  console.log('Unknown Mode ', mode, 'Will send as Road')
  return 'ROAD'
}

let getState = function (gstNumber) {
  let stateCode = gstNumber.substring(0, 2)
  let stateMap = {
    35: 'ANDAMAN_AND_NICOBAR',
    28: 'ANDHRA_PRADESH',
    37: 'ANDHRA_PRADESH',
    12: 'ARUNACHAL_PRADESH',
    18: 'ASSAM',
    10: 'BIHAR',
    4: 'CHANDIGARH',
    22: 'CHHATTISGARH',
    26: 'DADAR_AND_NAGAR_HAVELI',
    25: 'DAMAN_AND_DIU',
    7: 'DELHI',
    30: 'GOA',
    24: 'GUJARAT',
    6: 'HARYANA',
    2: 'HIMACHAL_PRADESH',
    1: 'JAMMU_AND_KASHMIR',
    20: 'JHARKHAND',
    29: 'KARNATAKA',
    32: 'KERALA',
    31: 'LAKSHADWEEP',
    23: 'MADHYA_PRADESH',
    27: 'MAHARASTRA',
    14: 'MANIPUR',
    17: 'MEGHALAYA',
    15: 'MIZORAM',
    13: 'NAGALAND',
    21: 'ORISSA',
    34: 'PONDICHERRY',
    3: 'PUNJAB',
    8: 'RAJASTHAN',
    11: 'SIKKIM',
    33: 'TAMIL_NADU',
    36: 'TELENGANA',
    16: 'TRIPURA',
    9: 'UTTAR_PRADESH',
    5: 'UTTARAKHAND',
    19: 'WEST_BENGAL'
  }

  if (stateCode.startsWith('0')) stateCode = stateCode.substring(1, 2)
  stateCode = parseInt(stateCode)

  return stateMap[stateCode] || 'KA'
}

let salesParse = (row, genType) => {
  let consignee = {
    gstNumber: row[25],
    name: row[26],
    address: row[27].replace('\n', '').replace('\r', ''),
    pinCode: row[28],
    state: getState(row[25])
  }
  let consignor = {
    gstNumber: row[3],
    name: row[4],
    address: row[5].replace('\n', '').replace('\r', ''),
    pinCode: row[6],
    state: getState(row[3])
  }
  let isInvoice = row[9].toUpperCase().indexOf('INV') > -1
  let invoice = {
    invoiceNo: row[0],
    invoiceDt: parseDate(row[7]),
    invoiceVal: row[14],
    goodsDirection: genType === 'SALES' ? 'OUT' : 'IN',
    purpose: isInvoice ? 'SUPPLY' : 'OTHERS',
    docType: isInvoice ? 'INV' : 'CHL',
    otherValue: row.length > 53 ? parseFloat(row[53]) : 0.0
  }
  let transporter = {
    id: row[39],
    docNo: row[29],
    docDt: parseDate(row[40]),
    transportMode: parseTransportMode(row[24].toUpperCase()),
    vehicleNo: row[23],
    name: row[22]
  }
  console.log('Invoice ', invoice, ' Consignor', consignor, 'Consignee', consignee, 'Transporter', transporter)

  return {
    formId: uuid(),
    consignor: consignor,
    consignee: consignee,
    invoice: invoice,
    lineItems: [
      {
        commName: row[42],
        hsnCode: row[44],
        qty: parseFloat(row[12]),
        cgstRate: parseFloat(row[15].replace(/[^\d\\.]/, '')),
        cgst: parseFloat(row[18]),
        sgstRate: parseFloat(row[16].replace(/[^\d\\.]/, '')),
        sgst: parseFloat(row[19]),
        igstRate: parseFloat(row[17].replace(/[^\d\\.]/, '')),
        igst: parseFloat(row[20]),
        gross: parseFloat(row[14]),
        net: parseFloat(row[21])
      }
    ],
    transporter: transporter
  }
}
let getFloat = (w) => parseFloat(w.replace(/,/g, ''))
let importParse = (row, importPIN, importState, transporterId, consigneeGST, consigneePIN, vehicleNo, docketNo, from, to) => {
  let qty = getFloat(row[7])
  let docType = 'BOE'
  let goodsPurpose = 'IMPORT'

  let consignorName = row[17].trim()
  let consigneeName = ''

  let gross = getFloat(row[11].trim()) + getFloat(row[20].trim()) + getFloat(row[30].trim())
  let o = {
    formId: uuid(),
    consignor: {
      gstNumber: 'URP',
      name: consignorName,
      address: from,
      pinCode: importPIN,
      state: importState
    },
    billFrom: {
      gstNumber: 'URP',
      name: consignorName,
      address: from,
      pinCode: '999999',
      state: '99'
    },
    consignee: {
      gstNumber: consigneeGST,
      name: consigneeName,
      address: to,
      pinCode: consigneePIN,
      state: getState(consigneeGST.substring(0, 2))
    },
    invoice: {
      invoiceNo: row[2],
      invoiceDt: parseDate(row[3]),
      invoiceVal: getFloat(row[11]),
      goodsDirection: 'IN',
      purpose: goodsPurpose,
      docType: docType
    },
    lineItems: [
      {
        commName: row[6].trim(),
        hsnCode: row[18].replace(/^0-9/gi, ''),
        qty: qty,
        cgstRate: 0,
        cgst: 0,
        sgstRate: 0,
        sgst: 0,
        igstRate: parseInt(row[25].trim()),
        igst: getFloat(row[26].trim()),
        gross: gross,
        net: gross + getFloat(row[26].trim()),
        unit: 'NOS'
      }
    ],
    transporter: {
      id: transporterId,
      docNo: docketNo,
      docDt: moment(new Date()).format('YYYY-MM-DD'),
      transportMode: 'ROAD',
      vehicleNo: vehicleNo
    }
  }
  console.log('row', JSON.stringify(row), JSON.stringify(o))
  return o
}
export default {
  name: 'GeneratePage',
  components: {Loading},
  data() {
    return {
      credential: {},
      creds: [],
      genType: 'SALES',
      fileContent: '',
      pinCode: '',
      stateCode: '',
      transporterId: '',
      consigneePIN: '',
      selectedCred: null,
      file: null,
      emailTo: '',
      jobs: [],
      forms: [],
      ewaybills: [],
      selectedJob: null,
      csv: [],
      fixing: false,
      fixed: null,
      vehicleNo: '',
      docketNo: '',
      fromAddress: '',
      toAddress: '',
      jobServer: 'https://prod-1.e-waybill.in'
    }
  },
  computed: {},
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (this.$store.state.loggedIn) {
        axios.get(credUrl)
          .then(response => {
            this.creds = response.data
            let lastCred = JSON.parse(localStorage.getItem('LAST_CRED_EWB') || 'null')
            if (lastCred === null && this.creds.length > 0) {
              this.selectedCred = this.creds[0].id
            } else {
              this.selectedCred = lastCred
            }
            this.selectCred()
          }, error => {
            console.error('Error in Loading Creds', error)
          })
      } else {
        this.$router.push('/login')
      }
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  mounted: function () {
    this.checkStatus()
    window.setInterval(() => {
      this.checkStatus()
    }, 20000)
  },
  methods: {
    printAllUrl: function (job) {
      if (!job) return ''
      let s = job.date || moment().format('YYYY-MM-DD')
      return `${this.jobServer}/api/e-waybill/print-all?request_id=${job.requestId}&what=html-detail&date=${s}`
    },
    fixPrintUrl: function (job) {
      let s = job.date || moment().format('YYYY-MM-DD')
      return `${this.jobServer}/api/e-waybill/populate-print?request_id=${job.requestId}&what=html-detail&date=${s}`
    },
    fixPrint: function (job) {
      if (!job) return
      this.fixing = true
      this.fixed = null
      axios.get(this.fixPrintUrl(job))
        .then(resp => {
          setTimeout(() => {
            this.fixing = false
            this.fixed = true
          }, 60 * 1000)
        })
    },
    generateEWB: function () {
      this.makeRequest()
    },
    validEwbs: function (job) {
      return job.ewaybills.filter(e => e.ewaybill && e.ewaybill.length === 12)
    },
    printAll: function (job) {
      console.log('Printing', job)
      let validEntries = job.ewaybills.filter(e => e.ewaybill && e.ewaybill.length === 12).map(e => e.ewaybill).join(",")
      let validEntriesInv = job.ewaybills.filter(e => e.ewaybill && e.ewaybill.length === 12).map(e => e.invoice.invoiceNo).join(",")
      window.open(`${this.jobServer}/api/e-waybill/print-all-ewb?request_id=${job.requestId}&ewb=${validEntries}&inv=${validEntriesInv}`, "_blank")
    },
    printAllNewUrl: function (job) {
      console.log('Printing', job)
      return `${this.jobServer}/api/e-waybill/print-all-ewb?request_id=${job.requestId}`
    },
    selectCred: function () {
      localStorage.setItem('LAST_CRED_EWB', JSON.stringify(this.selectedCred))
      this.credential = this.creds.filter(c => c.id === this.selectedCred)[0]
      console.log('Selected Credential', this.credential)
    },
    processFile: function (event) {
      let fileReader = new FileReader()
      let self = this
      fileReader.onload = function (e) {
        self.fileContent = fileReader.result
        self.csv = Papa.parse(self.fileContent, {delimiter: '\t'}).data
        self.makeEwaybills()
      }
      fileReader.readAsText(event.target.files[0])
    },
    selectJob: function (job) {
      console.log('Select', job)
      this.selectedJob = job
    },
    removeJob: function (job) {
      console.log('Remove', job)
      let existingItems = JSON.parse(localStorage['JOBS'] || '[]')
      let remainingJobs = existingItems.filter(e => e.requestId !== job.requestId)
      this.jobs = remainingJobs
      localStorage.setItem('JOBS', JSON.stringify(remainingJobs))
      if (this.selectedJob && this.selectedJob.requestId === job.requestId) {
        this.selectedJob = null
      }
    },
    makeEwaybills: function () {
      let genType = this.genType.trim()
      let pinCode = this.pinCode.trim()
      let stateCode = this.stateCode.trim()
      let transporterId = this.transporterId.trim()
      let gstNumber = this.credential.gstNumber.trim()
      let consigneePIN = this.consigneePIN.trim()
      let vehicleNo = this.vehicleNo.trim()
      let docketNo = this.docketNo.trim()
      let fromAddress = this.fromAddress.trim()
      let toAddress = this.toAddress.trim()
      console.log('genType', genType, pinCode, stateCode, transporterId, gstNumber, consigneePIN, vehicleNo, docketNo)
      let items = this.csv
        .filter((row, idx) => idx > 0)
        .filter((row, _) => row[12])
        .filter((row, _) => row.length > 25)
        .map((row) => {
          if (genType === 'SALES' || genType === 'RETURN') {
            return salesParse(row, genType)
          } else {
            return importParse(row, pinCode, stateCode, transporterId, gstNumber, consigneePIN, vehicleNo, docketNo, fromAddress, toAddress)
          }
        })
        .filter(row => row['consignor']['gstNumber'])

      this.csv = null
      let groupsBy = _.groupBy(items, function (item) {
        return item.invoice.invoiceNo
      })
      console.info(JSON.stringify(groupsBy))

      let ewaybills = []
      Object.keys(groupsBy).forEach(dbin => {
        let ewaybill = groupsBy[dbin][0]
        ewaybill.lineItems = groupsBy[dbin].map(item => item.lineItems[0])
        if (genType === "IMPORT") {
          console.log("taking original invoice", ewaybill.invoice)
        } else {
          ewaybill.invoice.invoiceVal = _.sum(ewaybill.lineItems.map(li => li.net)) + ewaybill.invoice.otherValue
          console.log("calculated invoice", ewaybill.invoice)
        }

        ewaybills.push(ewaybill)
      })
      this.ewaybills = ewaybills
    },
    makeRequest: function () {
      let credential = this.credential
      let payload = {
        requestId: uuid(),
        credentials: {
          userName: credential.userName,
          password: credential.password,
          gstNumber: credential.gstNumber,
          loginType: 'TXP'
        },
        ewaybills: this.ewaybills
      }

      this.postToServer(payload)
    },
    postToServer: function (payload) {
      if (payload.ewaybills.length > 0) {
        axios.post(`${this.jobServer}/api/e-waybill/generate`, payload)
          .then(response => {
            console.log("Ewaybill error", response.data)

            if (response.data.ewaybillError) {
              console.error("Ewaybill error", response.data.ewaybillError)
              alert(response.data.ewaybillError)
              return
            }
            console.log('Payload Post OKay')
            this.saveToDB(payload)
          }, error => {
            console.error('Error in Posting Payload', error)
          })
      } else {
        alert('No EWaybills to Generate')
      }
    },
    saveToDB: function (payload) {
      let job = Object.assign({status: 'INIT'}, payload)
      job.ewaybills.forEach(ewb => {
        ewb.generating = true
        ewb.ewaybill = null

        ewb.lineItems.forEach(li => {
          li.itemId = uuid()
        })
      })
      job.totalCount = job.ewaybills.length
      job.successCount = 0
      job.failureCount = 0
      job.date = moment().format('YYYY-MM-DD')

      let existingItems = JSON.parse(localStorage['JOBS'] || '[]')
      existingItems.push(job)
      localStorage.setItem('JOBS', JSON.stringify(existingItems))
      this.selectedJob = job
      this.jobs = existingItems
    },
    checkStatus: function () {
      let jobs = JSON.parse(localStorage['JOBS'] || '[]')
      this.jobs = jobs
      let pendingJobs = jobs.filter(j => j.status !== 'COMPLETED')
      pendingJobs.forEach(job => {
        this.checkJobStatus(job)
      })
    },
    checkJobStatus: function (job) {
      axios.get(`${this.jobServer}/api/e-waybill/status?request_id=${job.requestId}`)
        .then(response => {
          let result = response.data
          job.emailTo = this.emailTo
          job.status = result.status

          job.ewaybills.forEach(ewb => {
            if (result.successForms.indexOf(ewb.formId) > -1) {
              ewb.generating = false
              ewb.ewaybill = result.generatedEWaybills[ewb.formId]
            } else if (result.failForms.indexOf(ewb.formId) > -1) {
              ewb.generating = false
              ewb.errorMsg = result.errors[ewb.formId]
            }
          })
          job.successCount = result.successCount
          job.failureCount = result.failCount

          // set to localDB
          let jobs = JSON.parse(localStorage['JOBS'] || '[]')
          let otherJobs = jobs.filter(j => j.requestId !== job.requestId)
          otherJobs.push(job)

          this.jobs = otherJobs
          localStorage.setItem('JOBS', JSON.stringify(otherJobs))

          if (job.status === 'COMPLETED') {
            console.log('Save to APP DB about the user and stuff')

            axios.post('/app/ewb/job-complete', job)
              .then(response => {
                console.log('Sent to app', response)
              }, error => {
                console.error('error in saving to app', error)
              })
          }
          console.log('selectedJob?', this.selectedJob, 'job?', job)
          if (this.selectedJob == null || job.requestId === this.selectedJob.requestId) {
            this.selectedJob = job
          }
        }, error => {
          console.error('Error in Job Status', error, job)
        })
    },
    fmt: function (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    printUrl: (f) => {
      let host = `${this.jobServer}/api/e-waybill/print`
      return `${host}?ewaybill=${f.ewaybill}&invoiceno=${f.invoice.invoiceNo}&pdf-detail=true`
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GeneratePage.vue